import { Box } from '@mui/material';
import { TournamentAccessibility } from '@okletsplay/core';
import { TournamentEntity } from 'app/interfaces/entity';
import { PassphraseIndicator } from 'modules/tournaments/components/PassphraseIndicator';
import { TournamentStatus } from 'modules/tournaments/components/TournamentStatus';
import { TournamentStatusViewType } from 'modules/tournaments/enums';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { ShareButton } from 'shared/components/ShareButton';
import { AnnouncementButton } from 'shared/components/AnnouncementButton';
import { TrackButton } from 'shared/components/TrackButton';
import { useSharedLink } from 'modules/tournaments/hooks';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import { useStyles } from './TournamentSubheader.styles';
import { ToggleTournamentVisibilityButton } from 'shared/components/ToggleTournamentVisibilityButton';
import { TournamentSponsoredIndicator } from 'shared/components/TournamentSponsoredIndicator';

interface TournamentSubheaderProps {
  tournament: TournamentEntity;
}

export const TournamentSubheader: FC<TournamentSubheaderProps> = ({ tournament }) => {
  const { classes } = useStyles();
  const link = useSharedLink();

  const isSponsored = useSelector(currentTournamentSelector.isSponsoredTournament);

  return (
    <Box className={classes.root}>
      <Box className={classes.statusContainer}>
        <TournamentStatus
          tournament={tournament}
          viewType={TournamentStatusViewType.Header}
          showStatus={false}
        />
        {isSponsored && (
          <Box pl={2}>
            <TournamentSponsoredIndicator withSmallIcon />
          </Box>
        )}
      </Box>
      <Box display="flex">
        <ToggleTournamentVisibilityButton />
        <TrackButton />
        <AnnouncementButton />
        <ShareButton link={link} />
        {tournament?.accessibility === TournamentAccessibility.Private && <PassphraseIndicator />}
      </Box>
    </Box>
  );
};
